import { useEffect, useState } from "react";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Services from "../components/sections/Services";
import About from "../components/sections/About";
import Reviews from "../components/sections/Reviews";
import ServiceArea from "../components/sections/ServiceArea";
import Payment from "../components/sections/Payment";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";
import Navbar from "../components/sections/Navbar";

export default function Home() {
  const [installPromptEvent, setInstallPromptEvent] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setInstallPromptEvent(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const triggerInstall = async () => {
    if (!installPromptEvent) return;
    installPromptEvent.prompt();
    await installPromptEvent.userChoice;
    setInstallPromptEvent(null);
  };

  return (
    <main data-testid="home-page" className="overflow-x-hidden">
      <Navbar onInstall={installPromptEvent ? triggerInstall : null} />
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Reviews />
      <ServiceArea />
      <Payment />
      <Contact />
      <Footer onInstall={installPromptEvent ? triggerInstall : null} />
    </main>
  );
}
